import { Divider } from "@mui/material";
import React, { FC } from "react";

import { Box, Grid } from "@components/base";

interface CardGuideLine {
  index: number;
  active: boolean;
  isLast: boolean;
}

const CardGuideLine: FC<CardGuideLine> = ({ index, active, isLast }) => (
  <Grid container alignItems="center">
    <Grid flex={1}>{index > 0 && <Divider />}</Grid>
    <Grid>
      <Box className={`dot ${active && "active"}`}></Box>
    </Grid>
    <Grid flex={1}>{isLast && <Divider />}</Grid>
  </Grid>
);

export default CardGuideLine;
